import type { Container } from 'pixi.js';
import type { IAPProductId } from '../../app/iap/types';
import type { ResourceMap } from '../../app/resources/types';
import type { IObservableValue } from '../../mainMenu/types';
import type { PiggyBankState } from './PiggyBankState';

export type PiggyBankObservable = IObservableValue<{
  levelIndex: number;
  coins: number;
  piggyBank: PiggyBankState | null;
}>;

export interface PiggyBankDependencies {
  observable: PiggyBankObservable;
  overlayContainer: Container;
  purchasePiggyBank: (tier: PiggyBankTier) => Promise<{ success: boolean; reward?: ResourceMap }>;
  getPiggyBankPrice: (tier: PiggyBankTier) => Promise<string | null>;
  watchAdForPiggyBank?: (tier: PiggyBankTier) => Promise<{ success: boolean; reward?: ResourceMap }>;
}

export enum PiggyBankTier {
  Legacy = 'Legacy', // This tier is for the first iteration of the piggybank, without tiers
  Normal = 'Normal',
  Silver = 'Silver',
  Gold = 'Gold',
  Opal = 'Opal',
  Diamond = 'Diamond',
}

export interface PiggyBankTierConfig {
  coinsPerLevel: number;
  maxCoins: number;
  durationHours: number | null;
  iap: IAPProductId;
  uiValue: number;
  assetBundle: string;
}

export type PiggyBankTierConfigMap = Record<PiggyBankTier, PiggyBankTierConfig>;
